import React from 'react';
import { useParams } from 'react-router-dom';
import CreateComplianceRecord from './CreateComplianceRecord';

const EditComplianceRecord = () => {
  const { id } = useParams();

  return <CreateComplianceRecord editMode={true} complianceId={id} />;
};

export default EditComplianceRecord;

